export default __webpack_public_path__ + "static/media/history.d4b37d38.png";